import React, { FC } from 'react'

import { Modal, Txt, Icon } from 'src/components/atoms'
import { AddInternalUserTooltip } from 'src/components/molecules'
import { CreateUser } from 'src/components/organisms'

import { useGetCustomRoles, useGetUsers } from 'src/hooks'

type Props = {
  isOpen: boolean
  onClose: () => void
}

export const CreateUserModal: FC<Props> = ({ isOpen, onClose }) => {
  const { refetch: refetchUsers } = useGetUsers()
  const { refetch: refetchCustomRoles } = useGetCustomRoles()

  const handleAfterCreateUser = async () => {
    await Promise.all([refetchCustomRoles(), refetchUsers()])
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="md"
      headerInner={
        <div className="tw-px-s1">
          <div className="tw-full-justify">
            <AddInternalUserTooltip>
              <div className="tw-flex tw-items-center">
                <Icon
                  size="--r1"
                  path="plus/soft/line"
                  className="tw-accent-standardText-secondary"
                />
                <Txt sizeType="l" className="tw-ml-r-3 tw-font-bold">
                  社内ユーザー追加
                </Txt>
              </div>
            </AddInternalUserTooltip>
          </div>
        </div>
      }
    >
      <div className="tw-w-[56.14rem] tw-p-s2">
        <CreateUser afterCreate={handleAfterCreateUser} />
      </div>
    </Modal>
  )
}
